// C:\MonProjet\BBW_DELEGUER\prod\babyworld-backoffice\babyworld-backoffice\src\components\layout\Main.js

import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Drawer } from "antd";
import { useSelector } from "react-redux"; 
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";
import './style.css';

const { Header: AntHeader, Content, Sider } = Layout;
const NO_NAV = "no-nav";

function Main({ children }) {
  const [visible, setVisible] = useState(false);
  const [fixed, setFixed] = useState(false);

  const openDrawer = () => setVisible(!visible);
  const handleFixedNavbar = (type) => setFixed(type);

  const location = useLocation();
  let pathname = location.pathname.replace("/", "");

  // Fermer automatiquement le Drawer mobile dès que l'utilisateur change de page
  useEffect(() => {
    setVisible(false);
  }, [location.pathname]);

  const user = useSelector((state) => state.signin.user);
  const userRole = user?.role?.name?.toLowerCase();
  const userIdRole = user?.role?.id;

  const isDelegate = userIdRole === 3;
  const isClinicOnly = userRole === "delegue clinique" || user?.email === "maternite@babyworld.tn";

  const shouldHideSidebar = ["sign-in"].includes(pathname) || isClinicOnly || isDelegate;

  return (
    <Layout className={`layout-dashboard ${pathname === "profile" ? "layout-profile" : ""}`}>
      
      {!shouldHideSidebar && (
        <>
          {/* DRAWER LATÉRAL POUR MOBILE / TABLETTE */}
          <Drawer
            placement="left"
            closable={true}
            onClose={() => setVisible(false)}
            open={visible}
            visible={visible}
            width={260}
            className="drawer-sidebar"
            bodyStyle={{ padding: 0, backgroundColor: "#fff" }}
          >
            <Sidenav />
          </Drawer>
          
          {/* BARRE LATÉRALE CLASSIQUE POUR GRAND ÉCRAN */}
          <Sider
            breakpoint="lg"
            collapsedWidth="0"
            trigger={null}
            width={250} 
            theme="light"
            className="sider-primary ant-layout-sider-primary"
          >
            <Sidenav />
          </Sider>
        </>
      )}

      <Layout className={shouldHideSidebar ? NO_NAV : ""} style={{ transition: 'all 0.2s' }}>
        {!shouldHideSidebar && (
          <AntHeader className={fixed ? "ant-header-fixed" : ""}>
            <Header
              onPress={openDrawer}
              name={pathname}
              handleFixedNavbar={handleFixedNavbar}
            />
          </AntHeader>
        )}
        <Content className="content-ant">{children}</Content>
        <Footer />
      </Layout>
    </Layout>
  );
}

export default Main;